import React from 'react';
import firebase from "../config/firebase";
import CssBaseline from '@material-ui/core/CssBaseline';
import clsx from 'clsx';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import IconButton from '@material-ui/core/IconButton';
import Moment from 'react-moment';
import { withStyles, makeStyles , useTheme} from '@material-ui/core/styles';
import MenuIcon from '@material-ui/icons/Menu';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';

import CircularProgress from '@material-ui/core/CircularProgress';
import { Table, TableRow, TableCell, TableHead, TableBody,
         Divider, Container, Drawer,
        } from '@material-ui/core';

import SidebarNav from './Sidebar.js';

const StyledTableCell = withStyles((theme) => ({
  head: {
    backgroundColor: theme.palette.common.light,
    color: theme.palette.common.black,
  },
  body: {
    fontSize: 14,
  },
}))(TableCell);

const StyledTableRow = withStyles((theme) => ({
  root: {
    '&:nth-of-type(odd)': {
      backgroundColor: theme.palette.background.default,
    },
  },
}))(TableRow);


const drawerWidth = 240; 

const useStyles = makeStyles((theme) => ({
    root: {
    flexGrow: 1,
    margin:theme.spacing(0),
    padding:theme.spacing(0),
    },
    title: {
    flexGrow: 1,
    textAlign:'left'
    }, 
    button: {
        margin: theme.spacing(1),
        float: 'right'
    },
    imgLogo: {
      width: "50px",
      marginRight: theme.spacing(1)
    },
    appBar: {
      transition: theme.transitions.create(['margin', 'width'], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
      }),
    },
    appBarShift: {
      width: `calc(100% - ${drawerWidth}px)`,
      marginRight: drawerWidth,
      transition: theme.transitions.create(['margin', 'width'], {
        easing: theme.transitions.easing.easeOut,
        duration: theme.transitions.duration.enteringScreen,
      }),
    },
    menuButton: {
      marginRight: theme.spacing(2),
    },
    hide: {
      display: 'none',
    },
    drawer: {
      width: drawerWidth,
      flexShrink: 0,
    },
    drawerPaper: {
      width: drawerWidth,
    },
    drawerHeader: {
      display: 'flex',
      alignItems: 'center',
      padding: theme.spacing(0, 1),
      // necessary for content to be below app bar
      ...theme.mixins.toolbar,
      justifyContent: 'flex-end',
    },
    content: {
      flexGrow: 1,
      marginTop: theme.spacing(1),
      padding: theme.spacing(0),
      paddingLeft: theme.spacing(2),
      transition: theme.transitions.create('margin', {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
      }),
      marginLeft: 0,
    },
    contentShift: {
      transition: theme.transitions.create('margin', {
        easing: theme.transitions.easing.easeOut,
        duration: theme.transitions.duration.enteringScreen,
      }),
      marginLeft: 0,
    },
    nav: {
      marginBottom: theme.spacing(2)
    },
    
 }));

  



function Healing (props) {
    
    const classes = useStyles();
    const theme = useTheme();

    const [voluntarios, setVoluntarios] = React.useState([]);
    const [vectores, setVectores] = React.useState([]);
    const [open, setOpen] = React.useState(false);

    const handleDrawerOpen = () => {
      setOpen(true);
    };
  
    const handleDrawerClose = () => {
      setOpen(false);
    };

    const GetBase = () => {
    
      return (
      <>
        <CssBaseline />
        <AppBar position="sticky" color="default" 
          className={clsx(classes.appBar, {[classes.appBarShift]: open, })}
        >
        <Toolbar id="back-to-top-anchor" >
          <img alt="Unidos Para Ayudar" className={classes.imgLogo} src={require('../assets/img/logo.png')} />
          <Typography className={classes.title} variant="h6">Unidos para Ayudar</Typography>
          <IconButton
            color="inherit"
            aria-label="open drawer"
            onClick={handleDrawerOpen}
            edge="start"
            className={clsx(classes.menuButton, open && classes.hide)}
          >
            <MenuIcon />
          </IconButton>
        </Toolbar>
        </AppBar>
        <Drawer
          className={classes.drawer}
          variant="persistent"
          anchor="right"
          open={open}
          classes={{
            paper: classes.drawerPaper,
          }}
        >
          <div className={classes.drawerHeader}>
            <IconButton onClick={handleDrawerClose}>
              {theme.direction === 'ltr' ? <ChevronRightIcon /> : <ChevronLeftIcon />}
            </IconButton>
          </div>
          <Divider />
          <SidebarNav 
          className={classes.nav} 
          />
        </Drawer>
      </>
      );
    };

    const fetchData = async () => {
      const db = firebase.firestore().collection('orgs').doc('unidos');
      
      const data = await db.collection("vectores")
            .orderBy("fechaAlerta", "asc")
            .get();
      setVectores(data.docs.map(x => ({...x.data(), id:x.id})));
      
      const dataCovid = await db.collection('orgs').doc('unidos').collection("users")
                  .where("covid", ">", 0)
                  .orderBy("covid", "asc")
                  .get();
      setVoluntarios(dataCovid.docs.map(x => ({...x.data(), id:x.id})));
    };

    React.useEffect(() => {
      fetchData();
    }, []);

    if (!voluntarios || !vectores)
      return (
        <div className={classes.root}>
          { GetBase() }
          <main
            className={clsx(classes.content, {
              [classes.contentShift]: open,
            })}
          >
          <Typography component="h1" variant="h5">
          Listado de Voluntarios con COVID (positivos y sospechosos)
          </Typography>
          <br></br>
          <Container spacing={2}>
          <CircularProgress />
          </Container>
          <Typography component="h1" variant="h5">
          Listado de Vectores de COVID
          </Typography>
          <Container spacing={2}>
          <CircularProgress />
          </Container>
          </main>
          </div>
      );

    
    return (
        <div className={classes.root}>
        { GetBase() }
        <main
              className={clsx(classes.content, {
                [classes.contentShift]: open,
              })}
            >
        <Typography component="h1" variant="h5">
        Listado de Voluntarios con COVID (positivos y sospechosos)
        </Typography>
        <br></br>
      <Table className={classes.table} size="small" aria-label="Voluntarios">
        <TableHead>
          <StyledTableRow>
          <StyledTableCell>Apellido</StyledTableCell>
          <StyledTableCell>Nombre</StyledTableCell>
          <StyledTableCell>Celular</StyledTableCell>
          </StyledTableRow>
        </TableHead>
        <TableBody>         
              {voluntarios.map(
                (vol, index ) => (
                  <StyledTableRow key={index}>
                    <StyledTableCell component="th" scope="row">
                    {vol.apellido}
                    </StyledTableCell>
                    <StyledTableCell >
                    {vol.nombre} 
                    </StyledTableCell>
                    <StyledTableCell >
                    {vol.celular} 
                    </StyledTableCell>
                  </StyledTableRow>
                )
              )}
        </TableBody>
        </Table>
        <br></br>
        <Typography component="h1" variant="h5">
        Listado de Vectores de COVID
        </Typography>
        <br></br>
        <Table className={classes.table} size="small" aria-label="Voluntarios">
        <TableHead>
          <StyledTableRow>
          <StyledTableCell>Fecha</StyledTableCell>
          <StyledTableCell>Origen</StyledTableCell>
          <StyledTableCell>Estado</StyledTableCell>
          </StyledTableRow>
        </TableHead>
        <TableBody>         
              {vectores.map(
                (vector, index ) => (
                  <StyledTableRow key={index}>
                    <StyledTableCell component="th" scope="row">
                    <Moment format="DD/MM HH:MM">{vector.fechaAlerta.toDate()}</Moment>
                    </StyledTableCell>
                    <StyledTableCell >
                    {vector.voluntarioNombre}
                    </StyledTableCell>
                    <StyledTableCell >
                    {vector.estado}
                    </StyledTableCell>
                  </StyledTableRow>
                )
              )}
        </TableBody>
        </Table>
      </main> 
      </div>
    );

}

export default Healing;